import React, { useState, useEffect, useContext } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { deleteFile, fetchFiles, uploadFileByCategory } from "../../api/files";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuFileUploader from "../../utils/smu-file-uploader/SmuFileUploader";
import _ from "lodash";
import { prepareText } from "../../helpers";
import SmuButton from "../../utils/smu-button/SmuButton";
import { IconBasket } from "../../icons/Icon";
import Swal from "sweetalert2";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { COLOR_PRIMARY } from "../../constants/colors";
import { StoreContext } from "../../store/StoreContext";
import SmuTable from "../../utils/smu-table/SmuTable";
import SmuSearch from "../../utils/smu-search/SmuSearch";
import { MANUALS_CATEGORY } from "../../constants/categories";
import moment from "moment";
import SmuLoading from "../../utils/smu-loading/SmuLoading";
import { checkPropTypes } from "prop-types";

const acceptedTypes = ["PDF"];



const LoadManuals = () => {
  const { manuals, setManuals, promotions } = useContext(StoreContext);
   
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredFiles, setFilteredFiles] = useState([]);

  useEffect(() => {
    handleGetManuals()
  }, []);

  const handleSearch = (_files, _search) => {
    return _files.filter((_file) => {
      const __search = prepareText(_search);
      const fileName = prepareText(_file.filename);
      return fileName.includes(__search);
    });
  };

  useEffect(() => {
    const _files = handleSearch(manuals, search);
    setFilteredFiles(_files);
  }, [search, manuals]);

  const handleGetManuals = () => {
    fetchFiles(MANUALS_CATEGORY).then((result) => {
      if (!result?.data?.data?.documents) return;
      setManuals([...result.data.data.documents]);
      setLoading(false);
    });
  };

  const handleUploadFile = async () => {
    const file = files[0];
    if (!file)
      return toast({
        icon: "error",
        title: "No fue posible cargar el archivo.",
      });

    const _promo = promotions.find((p) => {
      const description = prepareText(p.DESCRIPCION_PROMO);
      const _promotionName = prepareText(file.name);
      return _promotionName.includes(description);
    });

    if (!_promo)
      return toast({
        icon: "error",
        title: "No fue posible asociar el archivo a una promoción.",
      });

    const metadata = { fileName: file.name };
    const formData = new FormData();
    formData.append("document", file, file.name);
    formData.append("category", 0);
    formData.append("metadata", JSON.stringify(metadata));
    formData.append("promotion_id", _promo.ID_PROMO);
    formData.append("filetype", "Manual");

    const result = await uploadFileByCategory(formData);
    handleGetManuals();
    return result;
  };

  const handleDelete = (fileId) => {
    Swal.fire({
      title: "¿Deseas eliminar este manual?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      deleteFile(MANUALS_CATEGORY, fileId)
        .then(({ error }) => {
          if (!!error) throw new Error(error?.message);
          toast({ icon: "success", title: "Documento eliminado." });
        })
        .catch((err) => {
          console.error(err);
          toast({ icon: "error", title: "Ocurrio un error al eliminar. Por favor reintente" });
        })
        .finally(() => {
          handleGetManuals();
        });
    });
  };

  const columns = [
    {
      name: "Nombre de archivo",
      selector: (row) => row.filename,
      sortable: true,
      cell: (row) => <div className="cell text-truncate">{row.filename}</div>,
      width: "60%",
    },
    {
      name: "Visualizaciones",
      selector: (row) => row.views,
      sortable: true,
      cell: (row) => <div className="cell text-center">{row.views}</div>,
    },
    {
      name: "",
      selector: (row) => row.id,
      cell: (row) => (
        <div className="cell w-100 d-flex">
          <SmuButton
            _className="ms-auto"
            control={() => handleDelete(row.id)}
          >
            <IconBasket color="#33383F" />
          </SmuButton>
        </div>
      ),
    },
  ];

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex flex-column py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#B5E4CA" />
          <span className="fs-5 ms-3 me-auto">Cargar Manuales</span>
        </div>
      </Card.Header>
      <Card.Body className="d-flex flex-column">
        <Row>
          <Col
            col={12}
            lg={10}
            className={`offset-lg-1 ${promotions.length <= 0 ? "d-none" : ""}`}
          >
            <SmuFileUploader
              uploadFile={handleUploadFile}
              acceptedTypes={acceptedTypes}
              files={files}
              setFiles={setFiles}
              needPromo={true}
              verifyPrefix={true}
            />
          </Col>
          <Col
            col={12}
            lg={10}
            className={`offset-lg-1 ${promotions.length > 0 ? "d-none" : ""}`}
          >
            <SmuLoading label="Cargando promociones..." />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col col={12} lg={4} className="offset-lg-7">
            <SmuSearch value={search} onChange={e => setSearch(e.target.value)} />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col col={12} lg={10} className="offset-lg-1">
            <SmuTable
              columns={columns}
              data={filteredFiles}
              paginationPerPage={6}
              loading={loading}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LoadManuals;
